import { SearchAccountFormData } from 'core/cuenta/models/SearchAccountFormData';
import { useState } from 'react';
import { ACCOUNT_ERRORS, GENERIC_MESSAGES } from 'shared/constants/GenericMessages';
import { validateAccount } from 'shared/form/validations/ValidateAccount';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { FormWithValidation } from 'shared/form';

export const SearchAccountForm = ({
  performSearch,
  defaultAccountNumber,
  isPrevious,
}: {
  performSearch: (data: SearchAccountFormData) => void;
  defaultAccountNumber?: string;
  isPrevious?: boolean;
}) => {
  const [isSearchInputDisabled, setIsSearchInputDisabled] = useState(true);

  const searchAccount = (data) => {
    performSearch({
      cuenta: data.cuenta,
      option: data.option,
      selectdate: data.selectdate?.value,
    });
  };

  const optionChangeHandler = (event) => {
    const option = event.target.value;
    setIsSearchInputDisabled(option !== 'search');
  };

  return (
    <Card>
      <Card.Header>Totales del Organismo por Cuenta</Card.Header>
      <Card.Body>
        <FormWithValidation
          formProps={{
            defaultValues: {
              option: !!defaultAccountNumber ? 'search' : 'totals',
              cuenta: !!defaultAccountNumber ? defaultAccountNumber : '',
              selectdate: null,
            },
          }}
          onSubmit={searchAccount}
        >
          {!!isPrevious && (
            <Form.Group as={Row} className="mb-3" controlId="selectdate">
              <Form.Label column sm="3">
                Período
              </Form.Label>
              <Col sm="9">
                <FormWithValidation.LegacySelect.Period
                  isSearchable={true}
                  placeholder="Seleccione un período"
                  name="selectdate"
                  registerOptions={{
                    required: GENERIC_MESSAGES.dateRequired,
                  }}
                />
                <FormWithValidation.Control.Feedback
                  type="invalid"
                  controlId="selectdate"
                />
              </Col>
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <FormWithValidation.Check
              type="radio"
              name="option"
              id="option_totals"
              value="totals"
              label="Totales por cuenta"
              registerOptions={{
                onChange: optionChangeHandler,
                required: true,
              }}
            />
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="3">
              <FormWithValidation.Check
                type="radio"
                name="option"
                id="option_search"
                value="search"
                label="Total por tarjeta para la cuenta:"
                registerOptions={{
                  required: true,
                  onChange: optionChangeHandler,
                }}
              />
            </Form.Label>
            <Col sm="9">
              <FormWithValidation.Control
                type="text"
                data-testid="account-field"
                name="cuenta"
                registerOptions={{
                  disabled: isSearchInputDisabled,
                  required: ACCOUNT_ERRORS.accountRequired,
                  validate: (text: string) =>
                    validateAccount(text) || ACCOUNT_ERRORS.accountInvalid,
                }}
              />
              <FormWithValidation.Control.Feedback type="invalid" controlId="cuenta" />
            </Col>
          </Form.Group>
          <Row>
            <Col>
              <Button type="submit" variant="primary">
                Consultar
              </Button>
            </Col>
          </Row>
        </FormWithValidation>
      </Card.Body>
    </Card>
  );
};
